<script>
export default {
  name: 'SignatureDialog',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    signedBy: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(value) {
        return this.$emit('input', value)
      },
    },
    signedByName() {
      return this.signedBy || this.$store.state.accountName
    },
  },
  methods: {
    submitSignature() {
      const signature = this.$refs.signature.getSignature()
      this.$emit('signed', signature)
      this.showDialog = false
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="showDialog"
    transition="scroll-y-transition"
    no-click-animation
    internal-activator
    max-width="800"
    scrollable
  >
    <v-card>
      <v-toolbar>
        <v-btn icon @click="showDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title> Sign Off </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-spacer />
        <v-row>
          <v-col v-if="showDialog" cols="12" class="text-center mt-10">
            <label>
              <h4 v-text="`Signed by ${signedByName}`" />
            </label>
            <SignatureBox ref="signature" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          size="sm"
          class="float-right"
          @click="submitSignature"
        >
          Sign Off
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
